import { createClient } from '@sanity/client'

export default createClient({
    projectId: 'fosknyrt',
    dataset: 'production',
    apiVersion: '2023-06-30',
    useCdn: true, // turn on (true) when ready to deploy
})
